import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';
import KeenSlider from "keen-slider";

export default class ThemeImageGallery {

	constructor(dom) {
		// Vars
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		this.NAME = `THEME IMAGE GALLERY`;
		Logger.info(`${this.NAME} > init`);
		this.dom = dom;
		this.prev_btn = this.dom.querySelector('[data-theme-image-gallery-arrow-left]');
		this.next_btn = this.dom.querySelector('[data-theme-image-gallery-arrow-right]');
		this.imageGallery = new KeenSlider(
			'[data-theme-image-gallery-carousel]',
			{
				loop: true,
				mode: "free-snap",
				selector: "[data-theme-image-gallery-card]",
				initial: 0,
				variableWidth: true,
				slides: {
					perView: 1,
					spacing: 20,
				},
				breakpoints: {
					'(min-width: 540px)': {
						slides: {
							perView: 2,
							spacing: 20,
						},
					},
					'(min-width: 720px)': {
						slides: {
							perView: 3,
							spacing: 20,
						},
					},
					'(min-width: 960px)': {
						slides: {
							// perView: 5,
							perView: 4,
							spacing: 20,
						},
					},
				},
				created: (evt) => {
					console.info(`${this.NAME} > Slider > created > Slider has been created`);
					this.addHandlers();
				},
				detailsChanged: (evt) => {
					// console.info(`${this.NAME} > Slider > detailsChanged > The details-property has changed. At each movement, after an option change, and at each initialization or resizing`);
				},
				/*dragEnded: (evt) => {
				 console.info(`${this.NAME} > Slider > dragEnded > Drag has ended`);
				 },*/
				optionsChanged: (evt) => {
					// console.info(`${this.NAME} > Slider > optionsChanged > Options have changed, e.g. due to an update, resizing(when the number of slides changes) or a change of the breakpoint`);
				},
				slideChanged: (evt) => {
					// console.info(`${this.NAME} > Slider > slideChanged > Active or most visible slide has changed`, evt.track?.details?.rel);
					// console.info(evt.slides[evt.track?.details?.rel].style.transform);
				},
				updated: (evt) => {
					// console.info(`${this.NAME} > Slider > updated > the update function was called due to a size change or other trigger`, evt);
				},
			}
		);
	}

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	/**
	 * Add Handlers
	 */
	addHandlers() {
		console.log(`${this.NAME} > addHandlers`);
		this.next_btn.addEventListener("click", (evt) => this.onNext(evt));
		this.prev_btn.addEventListener("click", (evt) => this.onPrevious(evt));
	}

	/**
	 * onNext --- Advance 1 slide
	 * @param evt
	 */
	onNext(evt) {
		console.log(`${this.NAME} > onNext`);
		this.imageGallery.next();
	}

	/**
	 * Go back to the previous slide
	 * @param evt
	 */
	onPrevious(evt) {
		console.info(`${this.NAME} > onPrevious`);
		this.imageGallery.prev();
	}
}

// Mixins
Object.assign(ThemeImageGallery.prototype, eventMixin);
